import { render, staticRenderFns } from "./intelligentModel.vue?vue&type=template&id=793cf670&scoped=true&"
import script from "./intelligentModel.vue?vue&type=script&lang=js&"
export * from "./intelligentModel.vue?vue&type=script&lang=js&"
import style0 from "./intelligentModel.vue?vue&type=style&index=0&id=793cf670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793cf670",
  null
  
)

export default component.exports